export default __webpack_public_path__ + "static/media/qorpo.c01e18d7.png";